
import { mapGetters } from 'vuex'
import CheckoutStepIndicator from '../components/checkout/CheckoutStepIndicator'
import SaleBanner from '../components/dashboard/SaleBanner'
import LocaleChanger from '../components/default/LocaleChanger'

export default {
  name: 'Checkout',
  components: { LocaleChanger, CheckoutStepIndicator, SaleBanner },

  data () {
    return {
      activeStep: 0
    }
  },

  head: {
    script: [
      {
        type: 'text/javascript',
        src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
        async: true
      }
    ]
  },

  computed: {
    ...mapGetters({
      showSaleBanner: 'salebanner/getVisible'
    }),
    steps () {
      return [
        {
          name: this.$route.query.product || this.$store.state.payment.product?.type === 'product'
            ? this.$t('dashboard.checkout.steps.choose_product')
            : this.$t('dashboard.checkout.steps.choose_plan'),
          page: 'dashboard-checkout',
          movement: {
            forwards: true,
            // only allow going back to the beginning (step index 0)
            backwards: [0]
          }
        },
        {
          name: this.$t('dashboard.checkout.steps.payment'),
          page: 'dashboard-checkout-payment',
          movement: {
            forwards: true,
            // only allow going back to the beginning (step index 0)
            backwards: this.$store.state.payment.product?.type === 'product' ? false : [0]
          }
        },
        {
          name: this.$t('dashboard.checkout.steps.overview'),
          page: 'dashboard-checkout-overview'
        }
      ]
    }
  },

  watch: {
    '$route.name' (newValue) {
      for (const [index, step] of this.steps.entries()) {
        if (step.page === newValue) {
          this.activeStep = index

          return
        }
      }

      this.activeStep = 0
    }
  }
}
